import { render, staticRenderFns } from "./Efficency.vue?vue&type=template&id=ad41dfec&scoped=true&"
import script from "./Efficency.vue?vue&type=script&lang=ts&"
export * from "./Efficency.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad41dfec",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad41dfec')) {
      api.createRecord('ad41dfec', component.options)
    } else {
      api.reload('ad41dfec', component.options)
    }
    module.hot.accept("./Efficency.vue?vue&type=template&id=ad41dfec&scoped=true&", function () {
      api.rerender('ad41dfec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/analytics/Efficency.vue"
export default component.exports